// extracted by mini-css-extract-plugin
export default {"root":"_2ut3VK2F","right":"_33M482TC"};